import React from 'react'
import { View, ViewStyle } from 'react-native'
import { Avatar } from '../avatar'

interface ChoiceAvatarProps {
  show?: boolean
  photo?: string
  name: string
}
export const ChoiceAvatar = (props: ChoiceAvatarProps) => {
  const { show, photo, name } = props
  return show ? (
    <View style={{ ...AVATAR, opacity: show ? 1 : 0 }}>
      <Avatar size="small24" source={photo} name={name} />
    </View>
  ) : null
}

const AVATAR: ViewStyle = {
  height: 28,
  width: 28,
  zIndex: 9999,
  position: 'absolute',
  borderWidth: 2,
  borderColor: '#fff',
  borderRadius: 100,
  shadowColor: '#000',
  shadowRadius: 8,
  shadowOpacity: 0.25,
  shadowOffset: { width: 4, height: 4 },
  left: -8,
  bottom: -8,
}
